module.exports = __webpack_public_path__ + "img/sports.b07a6b1f.png";